import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromEmailTemplate from '../email-template/email-template.reducer'
import { TagModule } from '../tag/tag.module'
import { EmailTemplateRoutingModule } from './email-template-routing.module'
import { EmailTemplateEffects } from './email-template.effects'
import { EmailTemplateSerializer } from './email-template.serializer'
import { EmailTemplateService } from './email-template.service'

@NgModule({
  imports: [
    EmailTemplateRoutingModule,
    TagModule,
    SharedModule,
    StoreModule.forFeature(
      fromEmailTemplate.FEATURE_NAME,
      fromEmailTemplate.emailTemplateReducer
    ),
    EffectsModule.forFeature([EmailTemplateEffects])
  ],
  declarations: [],
  exports: [],
  providers: [
    EmailTemplateService,
    {
      provide: EmailTemplateSerializer,
      useClass: EmailTemplateSerializer
    }
  ]
})
export class EmailTemplateModule {}
